import { useTranslation } from "react-i18next";
import { Outlet } from "react-router-dom";
import { ConnectionLost } from "@/components/general/connection-lost/ConnectionLost";
import { useConnectionStatus } from "@/hooks/useConnectionStatus";
import { useEmbeddedLayout } from "@/hooks/useEmbeddedLayout";
import {
  TabsContainer,
  TabsContent,
  TabsList,
  TabsTrigger,
  useRouterTabs,
} from "../tabs";
import style from "./CashierPageWrapper.module.css";

interface CashierPageWrapperProps {
  title: string;
}

export const CashierPageWrapper = ({ title }: CashierPageWrapperProps) => {
  const { t } = useTranslation();
  // Temporary flag for mobile POC
  const isEmbeddedLayout = useEmbeddedLayout();
  const isConnected = useConnectionStatus();

  const tabPaths = {
    deposit: "/deposit",
    withdraw: "/withdraw",
    transfer: "/transfer",
    history: "/history",
  } as const;

  type TabKey = keyof typeof tabPaths;

  const tabLabels: Record<TabKey, string> = {
    deposit: t("deposit.title"),
    withdraw: t("withdrawals.title"),
    transfer: t("transfer.title"),
    history: t("transactions.history.title"),
  };

  const { activeValue, onChange } = useRouterTabs<TabKey>(tabPaths, "deposit");

  const handleTabChange = (val: TabKey) => {
    onChange(val);
  };

  return (
    <article className={style.page__wrapper}>
      {!isEmbeddedLayout && (
        <header className={style.page__header}>
          <h1>{title}</h1>
        </header>
      )}

      <TabsContainer value={activeValue} onChange={handleTabChange}>
        {!isEmbeddedLayout && (
          <TabsList>
            {(Object.keys(tabLabels) as TabKey[]).map((key) => (
              <TabsTrigger key={key} value={key}>
                {tabLabels[key]}
              </TabsTrigger>
            ))}
          </TabsList>
        )}

        <TabsContent value={activeValue}>
          {isConnected ? (
            <Outlet />
          ) : (
            <ConnectionLost sectionLabel={tabLabels[activeValue]} />
          )}
        </TabsContent>
      </TabsContainer>
    </article>
  );
};
